<!--suppress ALL -->
<template>
  <div>
    <home-nav></home-nav>
    <home-header></home-header>
    <div id="app">
      <router-view></router-view>
    </div>
    <home-footer></home-footer>
    <page-side></page-side>
    <msg-modal></msg-modal>
  </div>

</template>
<script>
    import topnav from 'components/common/topnav';
    import Header from 'components/common/header'
    import Footer from 'components/common/footer'
    import pageSide from 'components/common/pageSide';
    import msgModal from 'components/modal/msgModal'
    export default{
        // 注册组件
        components: {
            'home-nav': topnav,
            'home-header': Header,
            'home-footer': Footer,
            pageSide,
            msgModal
        },

        created(){

        },
        mounted(){
//            console.log(this.isIE());
            if(this.isIE()){
                this.$store.commit('msg', '为了获得更好的用户体验，建议您使用谷歌浏览器访问私募信息申报平台, 如有任何意见或者细节疑问反馈，请致电：0755-29330548（陈小姐）或发送邮件至：data@jfz.com进行对接；')
            }
        },
        methods:{
            isIE() { //ie?
              if (!!window.ActiveXObject || "ActiveXObject" in window){
                  return true;
              } else {
                  return false;
              }
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  html {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/app.vue